import { gql } from '@lichtblick/apollo';

export const GET_WORK_ORDER_FILES = gql`
  query GetWorkOrderFiles_V1($input: GetWorkOrderFilesInput!) {
    getWorkOrderFiles_V1(input: $input) {
      error
      data {
        parentId
        id
        name
        files {
          id
          uri
          fileName
          mimeType
          fileSize
          isSafe
          virusScanResult
          createdBy {
            id
            eMail
            firstName
            lastName
          }
          createdAtUtc
        }
      }
    }
  }
`;
